import { PRODUCT_ID_TO_VIDEOID_MAP } from '../constants'

export const getProductVideoId = (productId: string): string | undefined => {
  return PRODUCT_ID_TO_VIDEOID_MAP[productId]?.videoId
}

export const isLetterboxProduct = (productId: string | null): boolean => {
  if (productId === null) return false
  return !!PRODUCT_ID_TO_VIDEOID_MAP[productId]?.isLetterbox
}

export const hasProductVideo = (productId: string | null) => {
  if (productId === null) return false
  return !!getProductVideoId(productId)
}
